import { gql } from '@apollo/client';
import IconHistory from '@apollo/icons/default/IconHistory.svg';
import { Link } from '@apollo/orbit';
import classnames from 'classnames';
import React from 'react';

import { LocalTimestamp } from 'src/components/timestamp/Timestamp';
import { GraphQLTypes } from 'src/lib/graphqlTypes';

import { variantHomepageRouteConfig } from '../../routes';

export const ProposalHeaderDataVariantFragment = gql`
  fragment ProposalHeaderDataVariantFragment on GraphVariant {
    id
    proposal {
      id
      status
      displayName
      createdAt
      sourceVariant {
        id
        name
      }
      canEditProposal
    }
  }
`;

export const ProposalHeaderData = ({
  graphId,
  variant,
  className,
}: {
  graphId: string;
  variant: GraphQLTypes.ProposalHeaderDataVariantFragment;
  className?: string;
}) => {
  return (
    <div className={classnames(className, 'w-full shrink')}>
      <div className="flex items-center">
        <div className="mt-3 flex flex-col items-start gap-1">
          {variant.proposal && (
            <div className="flex items-center whitespace-pre-wrap text-base text-neutral">
              <IconHistory className="mr-2 text-icon-primary" />
              Created <LocalTimestamp
                value={variant.proposal.createdAt}
              /> from{' '}
              <Link
                to={variantHomepageRouteConfig.location({
                  graphId,
                  graphVariant: variant.proposal.sourceVariant?.name,
                })}
              >
                {variant.proposal.sourceVariant?.id}’s
              </Link>
              {' schema'}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
